import Animation from '../../animations/exiting-animation'
import StyleTweeners from '../style-tweeners'

class ExitingAnimation extends Animation {

  constructor (options) {
    super(options)
    this.styleTweeners = new StyleTweeners(this.styles)
  }

  animate (serie, entering, selection, merged, exiting) {
    let initialOffset = 0

    this._walkLine(exiting.selection().selectAll('.area-group'), merged, this._shrinkPath, initialOffset, {
      x: this.previous.scalers.x.center,
      y: this.previous.yScale
    })

    exiting.tween('grow-stroke', this.styleTweeners.growStroke(exiting))
           .tween('fade-out', this.styleTweeners.fadeOut(exiting))
  }
}

export default ExitingAnimation
